import React, { useEffect, useState } from "react";
import DefaultGrid from "../Default/DefaultGrid";
import { Button, Table, Pagination, Form, FormControl, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faSearch, faTrash } from "@fortawesome/free-solid-svg-icons";
import { icon, IconProp } from "@fortawesome/fontawesome-svg-core";
import ModalPedidoItem from "../Modal/ModalPedidoItem";
import ModalDelete from "../Modal/ModalDelete";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { toast } from "react-toastify";

interface ProdutoData {
  data: any,
  setData: any,
  reload: any
  tabela: any
}

interface ItemData {
  modelo: any;
  id_pedido: any;
  id_produto: any;
  tamanhos: { tamanho: string, ord: any, preco_unitario: number, quantidade: number, }[];
}

const GridPedidos: React.FC<ProdutoData> = ({ data, setData, reload, tabela }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<ItemData | null>(null);
  const [deleting, setDeleting] = useState<boolean>(false);
  const [produtos, setProdutos] = useState<any>(null);
  const [disableMap, setDisableMap] = useState<{ [key: string]: boolean }>({});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchModelo, setSearchModelo] = useState("");
  const [searchDescricao, setSearchDescricao] = useState("");

  const filteredData = Array.isArray(data)
    ? data.filter((item: any) =>
      (item?.modelo || "").toLowerCase().includes((searchModelo || "").toLowerCase()) &&
      (item?.descricao || "").toLowerCase().includes((searchDescricao || "").toLowerCase())
    )
    : [];


  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, itemModelo: string, columnKey: string) => {
    const { value } = e.target;

    setData((prevData: any) => {
      if (!Array.isArray(prevData)) return prevData; // Evita erro se prevData não for array
      return prevData.map((item) => {
        if (item.modelo === itemModelo) {
          return {
            ...item,
            grade: {
              ...item.grade,
              [columnKey]: Number(value) // Converte para número
            }
          };
        }
        return item;
      });
    });
  };


  const toggleEdit = (itemKey: string) => {
    setDisableMap((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };

  const handleDelete = () => {
    if (!selectedItem) return;

    console.log("Tentando excluir item:", selectedItem);
    setDeleting(true);

    api
      .delete(
        `${BackEndRoutes.routes.PEDIDOS.ITENS.DELETE}?id_pedido=${selectedItem.id_pedido}&id_produto=${selectedItem.id_produto}`
      )
      .then(() => {
        console.log("Item deletado com sucesso!");
        toast.success("Item removido com sucesso!");
        setShowModalDelete(false);
        setSelectedItem(null);
        reload(); // Recarrega a lista após a exclusão
      })
      .catch((error) => {
        console.error("Erro ao deletar item:", error);
        toast.error("Erro ao excluir o item. Tente novamente.");
      })
      .finally(() => setDeleting(false));
  };

  const columnInput = (item: any, column: any) => (
    <FormControl
      style={{ width: '45px' }}
      type="text"
      className="col-12 text-center form-control"
      onChange={(e: any) => handleChange(e, item.modelo, column.key)}
      value={item?.grade?.[column.key]}
      disabled={!disableMap[item.modelo]}
    />
  );

  const allColumns = [
    { key: "modelo", label: "REFERÊNCIA", minWidth: 0 },
    { key: "descricao", label: "DESCRIÇÃO", minWidth: 768 },
    {
      key: "search",
      label: <FontAwesomeIcon icon={faSearch} />,
      render: (item: any) => (
        windowWidth >= 1200 ? null : (
          <span className="d-flex justify-content-center align-items-center">
            <Button size="sm" className="col-12" onClick={() => { setShowModal(true); setProdutos(item); }} variant="secondary">
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </span>
        )

      ), minWidth: 0, maxWidth: 1200
    },
    { key: "34", label: 34, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "36", label: 36, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "38", label: 38, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "40", label: 40, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "42", label: 42, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "44", label: 44, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "46", label: 46, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "48", label: 48, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "50", label: 50, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "52", label: 52, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "54", label: 54, minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "56", label: "PP", minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "58", label: "P", minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "60", label: "M", minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "62", label: "G", minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "64", label: "GG", minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "66", label: "XG", minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "68", label: "XGG", minWidth: 1200, render: (item: any, column: any) => columnInput(item, column) },
    { key: "qtd_total", label: "QTD.", minWidth: 768 },
    { key: "preco", label: "UNIT.", minWidth: 768 },
    { key: "total", label: "TOTAL.", minWidth: 768 }
  ];


  const columns = allColumns.filter(col => windowWidth >= col.minWidth && (!col.maxWidth || windowWidth <= col.maxWidth));
  const paginatedData = Array.isArray(filteredData) ?
    filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
    : [];
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  // const paginatedData = data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const renderPagination = () => {
    const visiblePages = 4; // Número total de páginas visíveis
    let start = Math.max(1, currentPage - Math.floor(visiblePages / 2));
    let end = Math.min(totalPages, start + visiblePages - 1);

    // Ajustar início se estiver no final
    if (end - start + 1 < visiblePages) {
      start = Math.max(1, end - visiblePages + 1);
    }

    return (
      <Pagination className="justify-content-center">
        <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />

        {start > 1 && (
          <>
            <Pagination.Item onClick={() => setCurrentPage(1)}>1</Pagination.Item>

          </>
        )}

        {Array.from({ length: end - start + 1 }, (_, i) => i + start).map(page => (
          <Pagination.Item key={page} active={page === currentPage} onClick={() => setCurrentPage(page)}>
            {page}
          </Pagination.Item>
        ))}

        {end < totalPages && (
          <>

            <Pagination.Item onClick={() => setCurrentPage(totalPages)}>{totalPages}</Pagination.Item>
          </>
        )}

        <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
      </Pagination>
    );
  };


  return (
    <div className="card">
      <div className="card-body">

        <h4>ITENS</h4>
        <Row>
          <Col className="col-lg-5 col-md-5 col-8">
            <FormControl
              type="text"
              placeholder="Filtrar por Modelo"
              value={searchModelo}
              onChange={(e) => setSearchModelo(e.target.value)}
            />
          </Col>
          <Col className={`col-lg-5 col-md-5 col-12 ${windowWidth >= 768 ? '' : 'd-none'}`}>
            <FormControl
              type="text"
              placeholder="Filtrar por Descrição"
              value={searchDescricao}
              onChange={(e) => setSearchDescricao(e.target.value)}
            />
          </Col>
          <Col className="d-flex justify-content-end">
            <Form.Group controlId="itemsPerPageSelect" className="mb-3">
              <Form.Control as="select" value={itemsPerPage} className="text-center" onChange={(e) => (setItemsPerPage(Number(e.target.value)), setCurrentPage(1))}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>

        <div style={{ overflowX: "auto", minHeight: "200px" }}>
          <Table hover striped className="table-bordered">
            <thead className="sticky-top bg-light">
              <tr>
                {columns.map((column) => (
                  <th key={column.key} className="text-center">{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (paginatedData.map((item: any, index: any) => (
                <tr key={index}>
                  {columns.map((column) => (
                    <td key={column.key} className="text-center ">
                      {column.render ? column.render(item, column) : item[column.key]}
                    </td>
                  ))}
                  <td className="text-center">
                    <div className="d-flex justify-content-center gap-2">
                      <div className={`col-lg-5 col-md-5 col-12 ${windowWidth >= 1200 ? '' : 'd-none'}`}>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => toggleEdit(item.modelo)}
                        >
                          <FontAwesomeIcon icon={faEdit as IconProp} />
                        </Button>
                      </div>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => {
                          setShowModalDelete(true);
                          setSelectedItem(item);
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash as IconProp} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))) : <tr>
                <td colSpan={columns.length + 1} className="text-center">
                  Este pedido não possui nenhum item!
                </td>
              </tr>}
            </tbody>
          </Table>
        </div>
        {renderPagination()}
      </div>
      <ModalPedidoItem
        show={showModal}
        setShow={setShowModal}
        reload={reload}
        tabela={tabela}
        data={produtos}
        onCancel={() => setShowModal(false)}
      />
      <ModalDelete
        show={showModalDelete}
        title="Confirmar Exclusão"
        message={`Deseja confirmar a exclusão do Produto: ${selectedItem?.modelo}?`}
        loading={deleting}
        onConfirm={handleDelete}
        onCancel={() => {
          setShowModalDelete(false);
          setSelectedItem(null);
        }}
      />
    </div>
  );
};

export default GridPedidos;
